import { render, staticRenderFns } from "./SettingQuiz.vue?vue&type=template&id=a24eebac&scoped=true&"
import script from "./SettingQuiz.vue?vue&type=script&lang=js&"
export * from "./SettingQuiz.vue?vue&type=script&lang=js&"
import style0 from "./SettingQuiz.vue?vue&type=style&index=0&id=a24eebac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a24eebac",
  null
  
)

export default component.exports